export default "__VITE_ASSET__Bx$8HZ47__"